exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-wrapper[data-v-388337b6] {\n  border: 1px solid #e7eaf3;\n  box-shadow: 0 0 35px rgba(140, 152, 163, .125);\n  border-radius: .5rem;\n  margin-top: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n", ""]);

// exports
